import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19ac0faa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  class: "form-container",
  id: "mainFormTarget"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title apply-title" }, "投保人信息", -1))
const _hoisted_4 = { class: "van-hairline--bottom" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "投保人类型", -1))
const _hoisted_6 = { class: "radio-wrap" }
const _hoisted_7 = { class: "label-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "* 投保人与投保发票信息保持一致，如有公司发票需求请按企业投保。", -1))
const _hoisted_9 = {
  key: 0,
  class: "van-hairline--bottom"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "投保人姓名", -1))
const _hoisted_11 = { class: "name-wrap" }
const _hoisted_12 = {
  key: 1,
  class: "van-hairline--bottom"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "投保人身份证号码", -1))
const _hoisted_14 = {
  key: 2,
  class: "van-hairline--bottom"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "企业名称", -1))
const _hoisted_16 = {
  key: 3,
  class: "van-hairline--bottom"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "企业的统一社会信用代码", -1))
const _hoisted_18 = {
  key: 4,
  class: "van-hairline--bottom"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "团体名称", -1))
const _hoisted_20 = {
  key: 5,
  class: "van-hairline--bottom"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "工商运营执照号", -1))
const _hoisted_22 = { class: "van-hairline--bottom" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "邮箱地址", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-tips" }, "注：电子邮箱用于接收意外机损保险电子保单文件，请准确填写。", -1))
const _hoisted_25 = {
  class: "mt16",
  id: "mainFormInsurantTarget"
}
const _hoisted_26 = { class: "form-container" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "被保人信息", -1))
const _hoisted_28 = { class: "van-hairline--bottom" }
const _hoisted_29 = { class: "van-hairline--bottom" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "被保人类型", -1))
const _hoisted_31 = { class: "radio-wrap" }
const _hoisted_32 = { class: "label-item" }
const _hoisted_33 = {
  key: 0,
  class: "van-hairline--bottom"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "被保人名称", -1))
const _hoisted_35 = {
  key: 1,
  class: "van-hairline--bottom"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "被保人身份证号码", -1))
const _hoisted_37 = {
  key: 2,
  class: "van-hairline--bottom"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "企业名称", -1))
const _hoisted_39 = {
  key: 3,
  class: "van-hairline--bottom"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "企业的统一社会信用代码", -1))
const _hoisted_41 = {
  key: 4,
  class: "van-hairline--bottom"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "团体名称", -1))
const _hoisted_43 = {
  key: 5,
  class: "van-hairline--bottom"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "工商运营执照号", -1))
const _hoisted_45 = { class: "van-hairline--bottom" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label",
  "data-required": ""
}, "选择是否开票", -1))
const _hoisted_47 = {
  key: 0,
  class: "warning"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-tips" }, "注：仅支持普通电子发票，专票请联系平安客服 95511", -1))

import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { getEntryInfo } from '@/utils'
import { FormInstance } from 'vant/lib/form/index'
import { useLocactionInfo } from '@/compositions/common'
import { usePinanPay } from '@/compositions/insurance/usePay'
import { Field, Form, RadioGroup, Radio, FieldRule } from 'vant'
import { computed, reactive, ref, Ref } from 'vue'
import {
  getJijiaInsurancePersonalTypeOptions,
  JijiaInsranceCertifivateTextTypeMap,
} from '@/defination/insurance'
import { useValidateIDCard, useValiedateEmail } from '@/compositions/useValidate'
import {
  ConfirmInsureParams,
  ConfirmInsureParamsApplicantInfo,
  ConfirmInsureParamsInsurantInfo,
  ConfirmInsureParamsPersonnelType,
  ConfirmInsureParamsWaiveInfo,
} from '@/types/insurance'
import { USER_JIJIA_INSURANCE_BUY_LOCATION_AUTH } from '@/config/constant'
import { showConfirmModal, showToastFail } from '@/utils/tools'
import CommonRadioGroup from '@/components/CommmonRadioGroup.vue'
import JijiaGiveUpPopup from '../components/jijia-giveup-popup.vue'

interface FormInfoOtherParams {
  // 额外参数
  insuranceObjectType?: ConfirmInsureParamsPersonnelType // 投保人类型
  insuredObjectType?: ConfirmInsureParamsPersonnelType // 被保人类型
  compnayName: string // 企业名称
  groupName: string // 团体名称
  groupCertificateNo: string // 工商运营执照号
  compnayCertificateNo: '' // 企业统一信用代码
  insurantInfoType?: '1' | '0' // 被保人信息  1 同投保人  2 其他
}


export default /*#__PURE__*/_defineComponent({
  __name: 'insurance-form-main-info',
  emits: ['init', 'confirmGiveup'],
  setup(__props, { emit: emits }) {



const $route = useRoute()
const routeQuery = $route.query
const sn = routeQuery.sn as string
const pro_type = routeQuery.proType as string
const insurance_type = routeQuery.insurance_type as string
const entryData = getEntryInfo()
const isFromActive = entryData.type === 'active'
const personalTypeOptions = getJijiaInsurancePersonalTypeOptions(false)
const { getUserLocationLngLatWithAuth } = useLocactionInfo()
const needRefund = routeQuery.exist_policy === '1'
const cycle_year = routeQuery.cycle_year as string
const canUseEquity = Number(routeQuery.equity_type) === 1
const showGiveupPopup = ref(false)
const commonMessagesMap = {
  groupName: '请填写团体名称',
  groupCertificateNo: '请填写工商运营执照号',
  compnayName: '请填写企业名称',
  compnayCertificateNo: '请填写企业的统一社会信用代码',
}
const messagesMap = {
  applicant_info: {
    personnelType: '请选择投保人类型',
    name: '请填写投保人姓名',
    certificateNo: '请填写投保人的身份证号码',
    email: '请填写邮箱地址',
    invoicePrintType: '请选择是否开票',
    ...commonMessagesMap,
  },
  insurant_info: {
    personnelType: '请选择被保人类型',
    name: '请填写被保人名称',
    certificateNo: '请填写被保人的身份证号码',
    ...commonMessagesMap,
  },
}
const warningObj = reactive({
  tax: false,
})
const { payHandle } = usePinanPay()
function getFieldRuleConfig(
  key: 'applicant_info' | 'insurant_info',
  childKey: unknown
): FieldRule[] {
  const currentMessageMapItem = messagesMap[key]
  type p = keyof typeof currentMessageMapItem
  const result: FieldRule[] = [
    {
      required: true,
      trigger: 'onBlur',
      message: messagesMap[key][childKey as p],
    },
  ]
  if (childKey === 'email') {
    result.push({
      validator: useValiedateEmail,
      message: '请输入正确的邮箱格式',
    })
  }
  if (childKey === 'certificateNo') {
    result.push({
      validator: useValidateIDCard,
      message: '请输入正确的身份证号码',
    })
  }
  return result
}

const getApplicantInfoFieldRuleConfig = getFieldRuleConfig.bind(null, 'applicant_info')
const getInsurantInfoFieldRuleConfig = getFieldRuleConfig.bind(null, 'insurant_info')

const vueStore = useStore()
const isMiniProgram = computed(() => vueStore.getters.isMiniProgram)
const formVm: Ref<FormInstance | null> = ref(null)
const waiveInfo = {
  apply_file: '',
  code: '',
}
//const cacheKey = 'AuthGetUserInfo'
let hasAsk = ref(false) // 判断是否询问过回填

const applicant_info: ConfirmInsureParamsApplicantInfo & FormInfoOtherParams = reactive({
  // 投保人信息22
  personnelType: '1',
  linkManName: '',
  mobileTelephone: '',
  email: '',
  certificateNo: '',
  certificateType: '',
  invoicePrintType: '',
  taxpayerCertificateNo: '',
  name: '',
  // 额外参数
  compnayName: '', // 企业名称
  groupName: '', // 团队名称
  groupCertificateNo: '', // 工商运营执照号
  compnayCertificateNo: '',
  insuranceObjectType: '1',
})
const insurant_info: ConfirmInsureParamsInsurantInfo & FormInfoOtherParams = reactive({
  // 被保人信息
  personnelType: '1',
  linkManName: '',
  email: '',
  certificateNo: '',
  certificateType: '',
  mobileTelephone: '',
  name: '',
  // 额外参数
  compnayName: '', // 企业名称
  compnayCertificateNo: '',
  groupName: '', // 团队名称
  groupCertificateNo: '', // 工商运营执照号
  insurantInfoType: '1',
  insuredObjectType: '1',
})

const personalTypeValue = '1' // 个人选项值
const companyTypeValue = '0' // 企业选项值
const groupTypeValue = '2' // 团体选项值 仅定义在前端，后端接口没有这个定义
const isApplicantPersonal = computed(() => {
  // 投保人个人
  return applicant_info.insuranceObjectType === personalTypeValue
})
const isApplicantCompany = computed(() => {
  // 投保人企业
  return applicant_info.insuranceObjectType === companyTypeValue
})
const isApplicantGroup = computed(() => {
  // 投保人团体
  return applicant_info.insuranceObjectType === groupTypeValue
})
const isInsurantPersonal = computed(() => {
  return insurant_info.insuredObjectType === personalTypeValue
})
// 是否已实名
const unAuthIdentity = computed(() => {
  return vueStore.state.userInfo?.identity === 0
})

const isInsurantCompany = computed(() => {
  return insurant_info.insuredObjectType === companyTypeValue
})
const isInsurantGroup = computed(() => {
  return insurant_info.insuredObjectType === groupTypeValue
})
const isInsurantUseApplicantInfo = computed(() => {
  return insurant_info.insurantInfoType === '0'
})

function getSubmitInsurantInfoParams(
  applicantInfoParams: ConfirmInsureParamsApplicantInfo
): ConfirmInsureParamsInsurantInfo {
  // 获取被保人参数
  const isInsurantPersonalValue = isInsurantPersonal.value
  const realName = vueStore.state.userInfo.realName // 当前登录账号的实名制名称
  const mobile = vueStore.state.userInfo.mobile
  const isSameAsApplicantInfo = insurant_info.insurantInfoType === '1' // 同投保人
  const insurantParamsInfo = getInsurantParamsInfo()
  return {
    personnelType: isSameAsApplicantInfo
      ? applicantInfoParams.personnelType
      : insurant_info.insuredObjectType,
    linkManName: isSameAsApplicantInfo
      ? applicantInfoParams.linkManName
      : isInsurantPersonalValue
      ? insurant_info.name
      : realName,
    email: applicant_info.email,
    mobileTelephone: mobile,
    certificateNo: isSameAsApplicantInfo
      ? applicantInfoParams.certificateNo
      : insurantParamsInfo.certificateNo,
    certificateType: isSameAsApplicantInfo
      ? applicantInfoParams.certificateType
      : insurantParamsInfo.certificateType,
    name: isSameAsApplicantInfo ? applicantInfoParams.name : insurantParamsInfo.name,
  }
}
function getEntryInfoParams() {
  const keys = ['lng', 'lat', 'statusHeight', 'activeKey', 'type', 'client']
  return keys.map((key) => `${key}=${entryData[key]}`).join('&')
}
function getPayCallBackUrl(sn: string) {
  // 获取支付后的回调，考虑支付回调是固定的，所以需要一个中转页
  let query = `?eqSn=${sn}`
  if (isFromActive) {
    query = query + `&${getEntryInfoParams()}`
  }
  if (isMiniProgram.value) {
    query += `&mini=member`
  }
  return `${location.origin}/insurance/jijia-pay-success${query}`
}
function stringFormatter(value: string) {
  return typeof value === 'string' ? value.trim() : value
}
function getPinganPayReturnUrl(sn: string) {
  // 从平安收银台处返回时设置的url地址
  let query = `?eqSn=${sn}`
  if (isFromActive) {
    query = query + `&${getEntryInfoParams()}`
  }
  if (isMiniProgram.value) {
    query += `&mini=member`
  }
  return `${location.origin}/insurance/jijia-cancel-pay-return${query}`
}
function getApplicantParamsInfo(): {
  certificateNo: string
  certificateType: '01' | '03' | '04'
  name: string
} {
  return {
    certificateNo: isApplicantCompany.value
      ? applicant_info.compnayCertificateNo
      : isApplicantGroup.value
      ? applicant_info.groupCertificateNo
      : applicant_info.certificateNo,
    certificateType: isApplicantCompany.value ? '03' : isApplicantGroup.value ? '04' : '01',
    name: isApplicantCompany.value
      ? applicant_info.compnayName
      : isApplicantGroup.value
      ? applicant_info.groupName
      : applicant_info.name,
  }
}
function getInsurantParamsInfo(): {
  certificateNo: string
  certificateType: '01' | '03' | '04'
  name: string
} {
  return {
    certificateNo: isInsurantCompany.value
      ? insurant_info.compnayCertificateNo
      : isInsurantGroup.value
      ? insurant_info.groupCertificateNo
      : insurant_info.certificateNo,
    certificateType: isInsurantCompany.value ? '03' : isInsurantGroup.value ? '04' : '01',
    name: isInsurantCompany.value
      ? insurant_info.compnayName
      : isInsurantGroup.value
      ? insurant_info.groupName
      : insurant_info.name,
  }
}
async function getSubmitParams() {
  // 获取经纬度信息
  let errorMessage = ''
  let locationInfo = { lat: '0', lng: '0' }
  try {
    const data = await getUserLocationLngLatWithAuth(USER_JIJIA_INSURANCE_BUY_LOCATION_AUTH)
    if (data.unAuth) {
      errorMessage = '无法获取您的地理位置将无法进行投保，请允许授权'
    } else {
      locationInfo.lat = String(data.lat || 0)
      locationInfo.lng = String(data.lng || 0)
    }
  } catch (error) {
    errorMessage =
      (error as { message?: string })?.message || '获取地理位置失败，请检查是否开启位置权限'
  }
  if (errorMessage) {
    showConfirmModal({
      title: '获取位置信息失败',
      message: errorMessage,
      confirmButtonText: '知道了',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-confirm-error-class',
      showCancelButton: false,
    })
    return
  }
  // 格式化请求的参数
  const isApplicantPersonalValue = isApplicantPersonal.value
  const realName = vueStore.state.userInfo.realName // 当前登录账号的实名制名称
  const mobile = vueStore.state.userInfo.mobile
  const applicantCertificateInfo = getApplicantParamsInfo()
  const applicantInfoParams: ConfirmInsureParamsApplicantInfo = {
    personnelType: applicant_info.insuranceObjectType,
    // / 如果是个人投保时使用填写的值，如果不是使用账号真实名称;未实名的情况取填写的公司名称或团体名称，已和平安相关技术确认没影响
    linkManName: isApplicantPersonalValue
      ? applicant_info.name
      : realName || applicantCertificateInfo.name, // 如果是个人投保时使用填写的值，如果不是使用账号真实名称
    mobileTelephone: mobile,
    email: applicant_info.email,
    certificateNo: applicantCertificateInfo.certificateNo,
    certificateType: applicantCertificateInfo.certificateType,
    name: applicantCertificateInfo.name,
    invoicePrintType: applicant_info.invoicePrintType,
  }
  const params: ConfirmInsureParams = {
    sn,
    lat: locationInfo.lat,
    lng: locationInfo.lng,
    pro_type: pro_type,
    equity_type: canUseEquity ? 1 : 2,
    applicant_info: applicantInfoParams,
    insurant_info: getSubmitInsurantInfoParams(applicantInfoParams),
    return_url: getPinganPayReturnUrl(sn), // 测试没有返回的情况
    front_notify_url: `${getPayCallBackUrl(sn)}`,
    cycle_year,
    insurance_type,
  }
  if (isMiniProgram.value) {
    params.app_info = {
      app_id: 'wx43471742f3e783cb',
      app_type: 'WXMP',
      openid: entryData.openid,
    }
  }
  if (isApplicantCompany.value || isApplicantGroup.value) {
    params.applicant_info.taxpayerCertificateType = '02'
    params.applicant_info.taxpayerCertificateNo = applicantInfoParams.certificateNo
  }
  if (needRefund) {
    // 需要退保的需要额外的参数
    params.waive_info = { ...waiveInfo }
  }
  params.isSameApplyInfo = insurant_info.insurantInfoType === '1'
  console.log('params', params)
  return params
}
async function checkAuthInfo() {
  if (unAuthIdentity.value) {
    // 未实名认证时不授权获取
    return
  }
  // const cacheInfo = getStorage(cacheKey, sessionStorage)
  if (hasAsk.value) {
    return
  }
  // 询问是否帮助回填
  try {
    await showConfirmModal({
      title: '授权获取信息',
      message: '您同意直接获取您的相关实名信息以便快速完成投保信息的填写。',
      confirmButtonText: '同意',
      cancelButtonText: '不同意',
      className: 'nongfu-dialog-confirm-class',
    })
    // 回填数据
    const userInfo = vueStore.state.userInfo
    applicant_info.name = userInfo.realName
    // applicant_info.certificateNo = userInfo.idcard
    applicant_info.email = userInfo.email.trim()
  } catch (error) {
    console.log('error', error)
  }
  //setStorage(cacheKey, '1', sessionStorage)
  hasAsk.value = true
}
function customValidate() {
  // 自行校验Form没有默认支持的部分
  let bool = true
  if (!applicant_info.invoicePrintType) {
    warningObj.tax = true
    bool = false
  }
  return bool
}
async function validateHandle(): Promise<boolean> {
  // 验证参数
  let validateValue = true
  try {
    validateValue = customValidate()
    await formVm.value?.validate() // Form表单验证不通过会
  } catch (error) {
    console.log('error', error)
    validateValue = false
  }
  if (!validateValue) {
    showToastFail('请完善表单信息后再提交')
  }
  return validateValue
}

async function giveupConfirmHandle(data: ConfirmInsureParamsWaiveInfo) {
  waiveInfo.apply_file = data.apply_file
  waiveInfo.code = data.code
  emits('confirmGiveup')
}

emits('init', {
  validateHandle,
  getSubmitParams,
  showGiveupPopupHandle() {
    showGiveupPopup.value = true
  },
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Form), {
      class: "main-info",
      ref_key: "formVm",
      ref: formVm
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(CommonRadioGroup, {
                style: {"margin-top":"8px"},
                options: _unref(personalTypeOptions),
                value: applicant_info.insuranceObjectType,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((applicant_info.insuranceObjectType) = $event))
              }, {
                radioContent: _withCtx(({ data }) => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(data.label), 1),
                    _createElementVNode("div", null, "(" + _toDisplayString(_unref(JijiaInsranceCertifivateTextTypeMap).get(data.value as string)) + ")", 1)
                  ])
                ]),
                _: 1
              }, 8, ["options", "value"]),
              _hoisted_8
            ]),
            (_unref(isApplicantPersonal))
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    (!_unref(hasAsk) && !_unref(unAuthIdentity))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: checkAuthInfo,
                          class: "name-cover"
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(Field), {
                      modelValue: applicant_info.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((applicant_info.name) = $event)),
                      class: "xa-field nongfu-field-wrap",
                      placeholder: messagesMap.applicant_info.name,
                      rules: _unref(getApplicantInfoFieldRuleConfig)('name'),
                      disabled: !_unref(hasAsk) && !_unref(unAuthIdentity)
                    }, null, 8, ["modelValue", "placeholder", "rules", "disabled"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(isApplicantPersonal))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_unref(Field), {
                    modelValue: applicant_info.certificateNo,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((applicant_info.certificateNo) = $event)),
                    class: "xa-field nongfu-field-wrap",
                    placeholder: messagesMap.applicant_info.certificateNo,
                    rules: _unref(getApplicantInfoFieldRuleConfig)('certificateNo')
                  }, null, 8, ["modelValue", "placeholder", "rules"])
                ]))
              : _createCommentVNode("", true),
            (_unref(isApplicantCompany))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_unref(Field), {
                    modelValue: applicant_info.compnayName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((applicant_info.compnayName) = $event)),
                    class: "xa-field nongfu-field-wrap",
                    placeholder: messagesMap.applicant_info.compnayName,
                    rules: _unref(getApplicantInfoFieldRuleConfig)('compnayName')
                  }, null, 8, ["modelValue", "placeholder", "rules"])
                ]))
              : _createCommentVNode("", true),
            (_unref(isApplicantCompany))
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_unref(Field), {
                    modelValue: applicant_info.compnayCertificateNo,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((applicant_info.compnayCertificateNo) = $event)),
                    class: "xa-field nongfu-field-wrap",
                    placeholder: messagesMap.applicant_info.compnayCertificateNo,
                    rules: _unref(getApplicantInfoFieldRuleConfig)('compnayCertificateNo')
                  }, null, 8, ["modelValue", "placeholder", "rules"])
                ]))
              : _createCommentVNode("", true),
            (_unref(isApplicantGroup))
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_unref(Field), {
                    modelValue: applicant_info.groupName,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((applicant_info.groupName) = $event)),
                    class: "xa-field nongfu-field-wrap",
                    placeholder: messagesMap.applicant_info.groupName,
                    rules: _unref(getApplicantInfoFieldRuleConfig)('groupName')
                  }, null, 8, ["modelValue", "placeholder", "rules"])
                ]))
              : _createCommentVNode("", true),
            (_unref(isApplicantGroup))
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_unref(Field), {
                    modelValue: applicant_info.groupCertificateNo,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((applicant_info.groupCertificateNo) = $event)),
                    class: "xa-field nongfu-field-wrap",
                    placeholder: messagesMap.applicant_info.groupCertificateNo,
                    rules: _unref(getApplicantInfoFieldRuleConfig)('groupCertificateNo')
                  }, null, 8, ["modelValue", "placeholder", "rules"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_unref(Field), {
                modelValue: applicant_info.email,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((applicant_info.email) = $event)),
                class: "xa-field nongfu-field-wrap",
                formatter: stringFormatter,
                placeholder: messagesMap.applicant_info.email,
                rules: _unref(getApplicantInfoFieldRuleConfig)('email')
              }, null, 8, ["modelValue", "placeholder", "rules"])
            ]),
            _hoisted_24
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_unref(RadioGroup), {
                modelValue: insurant_info.insurantInfoType,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((insurant_info.insurantInfoType) = $event)),
                direction: "horizontal",
                class: "xa-radio-group form-radio-group",
                "checked-color": "#00C378"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Radio), { name: "1" }, {
                    default: _withCtx(() => [
                      _createTextVNode("同投保人")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Radio), { name: "0" }, {
                    default: _withCtx(() => [
                      _createTextVNode("其他")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            (_unref(isInsurantUseApplicantInfo))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createVNode(CommonRadioGroup, {
                      style: {"margin-top":"4px"},
                      options: _unref(personalTypeOptions),
                      value: insurant_info.insuredObjectType,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((insurant_info.insuredObjectType) = $event)),
                      class: "custom-radio-group"
                    }, {
                      radioContent: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, _toDisplayString(data.label), 1),
                          _createElementVNode("div", null, "(" + _toDisplayString(_unref(JijiaInsranceCertifivateTextTypeMap).get(data.value as string)) + ")", 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["options", "value"])
                  ]),
                  (_unref(isInsurantPersonal))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _hoisted_34,
                        _createVNode(_unref(Field), {
                          modelValue: insurant_info.name,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((insurant_info.name) = $event)),
                          class: "xa-field nongfu-field-wrap",
                          placeholder: messagesMap.insurant_info.name,
                          rules: _unref(getInsurantInfoFieldRuleConfig)('name')
                        }, null, 8, ["modelValue", "placeholder", "rules"])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(isInsurantPersonal))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _hoisted_36,
                        _createVNode(_unref(Field), {
                          modelValue: insurant_info.certificateNo,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((insurant_info.certificateNo) = $event)),
                          class: "xa-field nongfu-field-wrap",
                          placeholder: messagesMap.insurant_info.certificateNo,
                          rules: _unref(getInsurantInfoFieldRuleConfig)('certificateNo')
                        }, null, 8, ["modelValue", "placeholder", "rules"])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(isInsurantCompany))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _hoisted_38,
                        _createVNode(_unref(Field), {
                          modelValue: insurant_info.compnayName,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((insurant_info.compnayName) = $event)),
                          class: "xa-field nongfu-field-wrap",
                          placeholder: messagesMap.insurant_info.compnayName,
                          rules: _unref(getInsurantInfoFieldRuleConfig)('compnayName')
                        }, null, 8, ["modelValue", "placeholder", "rules"])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(isInsurantCompany))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _hoisted_40,
                        _createVNode(_unref(Field), {
                          modelValue: insurant_info.compnayCertificateNo,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((insurant_info.compnayCertificateNo) = $event)),
                          class: "xa-field nongfu-field-wrap",
                          placeholder: messagesMap.insurant_info.compnayCertificateNo,
                          rules: _unref(getInsurantInfoFieldRuleConfig)('compnayCertificateNo')
                        }, null, 8, ["modelValue", "placeholder", "rules"])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(isInsurantGroup))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _hoisted_42,
                        _createVNode(_unref(Field), {
                          modelValue: insurant_info.groupName,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((insurant_info.groupName) = $event)),
                          class: "xa-field nongfu-field-wrap",
                          placeholder: messagesMap.insurant_info.groupName,
                          rules: _unref(getApplicantInfoFieldRuleConfig)('groupName')
                        }, null, 8, ["modelValue", "placeholder", "rules"])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(isInsurantGroup))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _hoisted_44,
                        _createVNode(_unref(Field), {
                          modelValue: insurant_info.groupCertificateNo,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((insurant_info.groupCertificateNo) = $event)),
                          class: "xa-field nongfu-field-wrap",
                          placeholder: messagesMap.insurant_info.groupCertificateNo,
                          rules: _unref(getApplicantInfoFieldRuleConfig)('groupCertificateNo')
                        }, null, 8, ["modelValue", "placeholder", "rules"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _createVNode(_unref(RadioGroup), {
                modelValue: applicant_info.invoicePrintType,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((applicant_info.invoicePrintType) = $event)),
                direction: "horizontal",
                class: "xa-radio-group form-radio-group",
                "checked-color": "#00C378",
                onChange: _cache[17] || (_cache[17] = ($event: any) => (warningObj.tax = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Radio), { name: "01" }, {
                    default: _withCtx(() => [
                      _createTextVNode("是")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Radio), { name: "03" }, {
                    default: _withCtx(() => [
                      _createTextVNode("否")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (warningObj.tax)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(messagesMap.applicant_info.invoicePrintType), 1))
                : _createCommentVNode("", true)
            ]),
            _hoisted_48
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(JijiaGiveUpPopup, {
      show: showGiveupPopup.value,
      "onUpdate:show": _cache[18] || (_cache[18] = ($event: any) => ((showGiveupPopup).value = $event)),
      isPersonal: _unref(isApplicantPersonal),
      sn: _unref(sn),
      needRefund: needRefund,
      onConfirm: giveupConfirmHandle
    }, null, 8, ["show", "isPersonal", "sn"])
  ], 64))
}
}

})